import { AtendimentoInput } from 'graphql/types.generated'

import { EncaminhamentoFormModel } from './model'

export const convertNovoAtendimentoModelToInput = (
  cidadaoId: ID,
  atendimento: EncaminhamentoFormModel
): AtendimentoInput => {
  return {
    cidadao: cidadaoId,
    agendado: atendimento?.agendado,
    equipe: atendimento?.equipe?.id,
    lotacao: atendimento?.lotacao?.id,
    tiposServico: atendimento?.tiposServico,
  }
}
